var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("석유와 가스")])])]), _c('p', [_vm._v(" 케이아이이 시스템즈는 다양한 산업군을 대상으로 분석기 시스템에 대한 엔지니어링 및 통합 분야에서 풍부한 경험과 노하우를 보유하고 있습니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이를 기반으로 고객의 요구사항에 따라 맞춤형 분석기 패키지 시스템을 제공하고 최적화된 솔루션으로 고객의 요구사항을 만족시키기 위해 항상 최선을 다합니다. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--1"
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("석유 화학")])])]), _c('p', [_vm._v(" 케이아이이 시스템즈는 다양한 산업군을 대상으로 분석기 시스템에 대한 엔지니어링 및 통합 분야에서 풍부한 경험과 노하우를 보유하고 있습니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이를 기반으로 고객의 요구사항에 따라 맞춤형 분석기 패키지 시스템을 제공하고 최적화된 솔루션으로 고객의 요구사항을 만족시키기 위해 항상 최선을 다합니다. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--2"
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("발전소")])])]), _c('p', [_vm._v(" 케이아이이 시스템즈는 다양한 산업군을 대상으로 분석기 시스템에 대한 엔지니어링 및 통합 분야에서 풍부한 경험과 노하우를 보유하고 있습니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이를 기반으로 고객의 요구사항에 따라 맞춤형 분석기 패키지 시스템을 제공하고 최적화된 솔루션으로 고객의 요구사항을 만족시키기 위해 항상 최선을 다합니다. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--3"
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("재생 에너지")])])]), _c('p', [_vm._v(" 케이아이이 시스템즈는 다양한 산업군을 대상으로 분석기 시스템에 대한 엔지니어링 및 통합 분야에서 풍부한 경험과 노하우를 보유하고 있습니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이를 기반으로 고객의 요구사항에 따라 맞춤형 분석기 패키지 시스템을 제공하고 최적화된 솔루션으로 고객의 요구사항을 만족시키기 위해 항상 최선을 다합니다. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--4"
  })])])]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual-button-group"
  }, [_c('v-btn', {
    staticClass: "visual-button visual-prev mr-6 mr-lg-10",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "rgba(255, 255, 255, 0.25)"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow"
  })]), _c('v-btn', {
    staticClass: "visual-button visual-next",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "rgba(255, 255, 255, 0.25)"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow"
  })])], 1), _c('div', {
    staticClass: "visual-pagination text-right"
  })])])])]), _c('div', {
    staticClass: "count-wrap"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "count-group",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "count d-flex flex-column align-center justify-center text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32"
  }, [_vm._v(" Since 2002 ")]), _c('h2', {
    staticClass: "font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"
  }, [_c('span', {
    staticClass: "countup"
  }, [_vm._v("20")])]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-1",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.4)"
    }
  }, [_vm._v(" Years ")])]), _c('v-col', {
    staticClass: "count d-flex flex-column align-center justify-center text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32"
  }, [_vm._v(" Engineer ")]), _c('h2', {
    staticClass: "font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"
  }, [_c('span', {
    staticClass: "countup"
  }, [_vm._v("30")]), _vm._v("+")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-1",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.4)"
    }
  }, [_vm._v(" People ")])]), _c('v-col', {
    staticClass: "count d-flex flex-column align-center justify-center text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32"
  }, [_vm._v(" Project ")]), _c('h2', {
    staticClass: "font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"
  }, [_c('span', {
    staticClass: "countup"
  }, [_vm._v("1000")]), _vm._v("+")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-1",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.4)"
    }
  }, [_vm._v(" Times ")])])], 1)], 1)], 1)]), _c('section', {
    staticClass: "main-section main-section1"
  }, [_c('v-container', [_c('h3', {
    staticClass: "main-tit dot-tit"
  }, [_vm._v(" 해외 사업주 ")]), _c('v-row', _vm._l(_vm.overseas, function (oversea) {
    return _c('v-col', {
      key: oversea._id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "logo-thum-wrap"
    }, [_c('div', {
      staticClass: "logo-thum",
      style: "background-image: url(".concat(oversea.thumb, ");")
    })])]);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section2"
  }, [_c('v-container', [_c('h3', {
    staticClass: "main-tit dot-tit"
  }, [_vm._v(" 국내사업주 ")]), _c('v-row', _vm._l(_vm.domestics, function (domestic) {
    return _c('v-col', {
      key: domestic._id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "logo-thum-wrap"
    }, [_c('div', {
      staticClass: "logo-thum",
      style: "background-image: url(".concat(domestic.thumb, ");")
    })])]);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section3"
  }, [_c('v-container', [_c('h3', {
    staticClass: "main-tit dot-tit"
  }, [_vm._v(" 건설사 ")]), _c('v-row', _vm._l(_vm.epcs, function (epc) {
    return _c('v-col', {
      key: epc._id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "logo-thum-wrap"
    }, [_c('div', {
      staticClass: "logo-thum",
      style: "background-image: url(".concat(epc.thumb, ");")
    })])]);
  }), 1)], 1)], 1), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }